module.exports = __webpack_public_path__ + "static/media/home_hero_k12_flyers.ae5f3684.jpg";